import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Logo from '../../../assets/images/NicoLetras.webp'
import MenuLogo from '../../../assets/images/mini/menu.png'
import './style.css'
import DropDownButton from '../button/DropDownButton';

export default function TopBar() {

    const bar = useRef(null), nav = useRef(null);
    const navigate = useNavigate();
    const [firstLoad, setFirstLoad] = useState(true);
    const [shortBar, setShortBar] = useState(false);

    const [navigationShow, setNavigationShow] = useState(false);

    useEffect(() => {

      if(firstLoad){
        if(window.innerWidth < 850){
          setShortBar(true);
        }
        setFirstLoad(false);
      }

      window.addEventListener("resize", () => {
        if(window.innerWidth < 850 && !shortBar){
          setShortBar(true);
        }
        if(window.innerWidth > 850 && shortBar){
          setShortBar(false);
          setNavigationShow(false);
        }
      })

      //Se le quito la animacion de aparecer desde arriba a la TopBar
      //Para volver a activarla, descomentar la linea de abajo y cambiar en .css el atributo 'top' a -70px
      //bar.current.style.top = 0; 
    })

    function displayNavigationMenu(show){
      setNavigationShow(show);

      if(show && nav != null){
        nav.current.style.left = "0px";
      }else if(!show && nav != null){
        nav.current.style.left = "-350px";
      }
    }

    const buttons = (
      <>
        <button onClick={() => navigate("/productos/aires")}>Aires</button>
        <button onClick={() => navigate("/productos/insumos")}>Insumos</button>
        <button onClick={() => navigate("/productos/transporte")}>Transporte</button>
      </>
    )

    const longTopBar = (
      <>
        <img src={Logo} alt='' onClick={() => navigate("/")}/>
        <div className='ButtonDisplay'>
          <button onClick={() => navigate("/")}>Inicio</button>
          <DropDownButton text="Productos" onClick={() => navigate("/productos")} buttonList={buttons}/>
          <button onClick={() => navigate("/nosotros")}>Nosotros</button>
          <button onClick={() => navigate("/contacto")}>Contacto</button>
          <div className='VerticalSeparator'></div>
          <button onClick={() => navigate("/register")}>Técnicos</button>
          
        </div>
      </>
    ) /* <button onClick={() => navigate("/login")}>Mi Cuenta</button> */

    const shortTopBar = (
      <>
        <img className="menuSwitch" src={MenuLogo} alt='' onClick={() => displayNavigationMenu(!navigationShow)}/>
        <img className="logo" src={Logo} alt='' onClick={() => navigate("/")}/>
        <div className='ButtonDisplay2' ref={nav}>
          <button onClick={() => navigate("/")}>Inicio</button>
          <button onClick={() => navigate("/productos")}>Productos</button>
          <button onClick={() => navigate("/nosotros")}>Nosotros</button>
          <button onClick={() => navigate("/contacto")}>Contacto</button>
        </div>
      </>
    )

  return (
    <div className='Topbar' ref={bar}>
      {shortBar ? shortTopBar : longTopBar}
    </div>
  )
}
